var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{class:_vm.className},[_c('h4',[_vm._v(_vm._s(_vm.headContent))])]),_c('div',{staticClass:"box-survey-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }